import "@fortawesome/fontawesome-free/css/all.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import Vue from "vue";
import Vuetify from "vuetify"; // import full to allow shared library usage
import "vuetify/dist/vuetify.min.css";

const conf = {
  icons: {
    iconfont: ["md" || "fa"]
  },
  theme: {
    dark: false,
    themes: {
      light: {
        primary: "#17365d",
        secondary: "#2478b5",
        accent: "#17365d",
        info: "#17365d",
        cardbg: "#f0fafe",
        success: "#92d050",
        error: "#9b0d0d",
        warning: "#dba90f",
        readonly: "#adaaaa"
      }
    }
  }
};

Vue.use(Vuetify);

export default new Vuetify(conf);
